var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Menu'),_c('Banner'),_c('Welcome'),_c('SideInfo'),_c('Courses'),_c('Info'),_c('ThreeSlide'),_c('SideLeft'),_c('Contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }